import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { useCallback, useState } from "react";
import { ExternalIcon } from "@icons/ExternalIcon";
import { Button } from "@ui-kit/Button";
import { Menu } from "./Menu";

const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handlePress = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return (
    <>
      <Button
        type="iconRound"
        icon={<ExternalIcon color={colors.white} svgName="menu" />}
        onPress={handlePress}
      />
      <Menu isOpen={isOpen} onClose={handleClose} />
    </>
  );
};

export { MobileMenu };
